(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mse-cart-add-feedback"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const toast = document.getElementById('mse-cart-add-feedback');
    if (!toast || toast.dataset.ready) return;
    toast.dataset.ready = 'true';
    const content = toast.querySelector('[data-mse-feedback-content]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const snapshots = new WeakMap();
    const seen = new Set();
    let sequence = 0;
    let showTimer;
    let hideTimer;
    let lastOffer = 0;
    let flight;
    const inView = element => {
      if (!element) return false;
      const box = element.getBoundingClientRect();
      return box.width > 0 && box.height > 0 && box.bottom > 0 && box.top < innerHeight && box.right > 0 && box.left < innerWidth && getComputedStyle(element).visibility !== 'hidden';
    };
    const snapshot = source => {
      if (!source) return null;
      const scope = source.closest('[data-mse-color-wall-item], .mse-cart-extra, .card, .product') || source.closest('.shopify-section');
      const image = scope?.querySelector('img');
      const element = inView(image) ? image : source;
      if (!inView(element) || !image) return null;
      const rect = element.getBoundingClientRect();
      return { src: image.currentSrc || image.src, x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
    };
    document.addEventListener('click', event => {
      const source = event.target.closest('[data-mse-color-wall-item], [name="add"], .mse-quick-5ml, [data-mse-extra-variant]');
      if (source) snapshots.set(source, snapshot(source));
    }, true);
    const position = () => {
      const drawer = document.querySelector('cart-drawer[aria-hidden="false"]');
      const parent = drawer || document.body;
      if (toast.parentElement !== parent) parent.append(toast);
      const bars = drawer ? Array.from(drawer.querySelectorAll('.cart-drawer__summary')) : Array.from(document.querySelectorAll('#mse-global-checkout, .mse-cart-sticky-v11, .mse-color-wall__checkout'));
      const visibleBars = bars.filter(inView);
      const offset = visibleBars.reduce((bottom, bar) => Math.max(bottom, innerHeight - bar.getBoundingClientRect().top + 10), 12);
      toast.style.setProperty('--mse-feedback-offset', Math.min(offset, innerHeight * .55) + 'px');
      if (drawer) {
        const box = drawer.getBoundingClientRect();
        toast.style.left = '50%';
        toast.style.width = Math.min(420, box.width - 24) + 'px';
      } else {
        toast.style.left = '50%';
        toast.style.width = '';
      }
    };
    const close = () => {
      clearTimeout(hideTimer);
      clearTimeout(showTimer);
      sequence += 1;
      toast.hidden = true;
    };
    const expire = () => {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(() => {
        if (toast.contains(document.activeElement) || toast.matches(':hover') || toast.querySelector('[aria-busy="true"]')) expire();
        else close();
      }, 8000);
    };
    toast.querySelector('[data-mse-feedback-close]').addEventListener('click', close);
    toast.addEventListener('pointerenter', () => clearTimeout(hideTimer));
    toast.addEventListener('pointerleave', expire);
    toast.addEventListener('focusin', () => clearTimeout(hideTimer));
    toast.addEventListener('focusout', expire);
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && !toast.hidden) close(); });
    const fly = source => {
      const state = snapshots.get(source) || snapshot(source);
      const target = [document.getElementById('cart-icon'), document.querySelector('#mse-global-checkout:not([hidden]) button'), document.querySelector('.mse-color-wall__checkout')].find(inView);
      if (!state || !inView(target) || reduced.matches) return;
      flight?.remove();
      const box = target.getBoundingClientRect();
      const image = document.createElement('img');
      image.className = 'mse-cart-flying-product';
      image.src = state.src;
      image.alt = '';
      image.setAttribute('aria-hidden', 'true');
      image.style.left = state.x - 28 + 'px';
      image.style.top = state.y - 28 + 'px';
      document.body.append(image);
      flight = image;
      const dx = box.left + box.width / 2 - state.x;
      const dy = box.top + box.height / 2 - state.y;
      const animation = image.animate([
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: `translate(${dx * .45}px,${dy * .45 - 35}px) scale(.75)`, opacity: .9, offset: .45 },
        { transform: `translate(${dx}px,${dy}px) scale(.2)`, opacity: 0 }
      ], { duration: 600, easing: 'ease-in-out' });
      animation.onfinish = () => image.remove();
      animation.oncancel = () => image.remove();
    };
    document.addEventListener('mse:cart:item-added', event => {
      const detail = event.detail || {};
      fly(detail.source);
      if (detail.recommend === false) { close(); return; }
      const current = ++sequence;
      clearTimeout(showTimer);
      const delay = Math.max(850, Number(detail.delay) || 0);
      showTimer = setTimeout(async () => {
        if (current !== sequence || Date.now() - lastOffer < 12000) return;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + '?section_id=mse-cart-extras', { cache: 'no-store' });
          if (!response.ok || current !== sequence) return;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (current !== sequence) return;
          const widget = doc.querySelector('[data-mse-cart-extras]');
          if (!widget) return;
          const cards = Array.from(widget.querySelectorAll('[data-mse-extra-cards] > .mse-cart-extra'));
          const card = cards.find(item => !seen.has(item.querySelector('[data-mse-extra-variant]')?.dataset.mseExtraVariant));
          if (!card) return;
          cards.forEach(item => { if (item !== card) item.remove(); });
          widget.dataset.static = 'true';
          widget.querySelector('[data-mse-extra-reserve]')?.remove();
          content.replaceChildren(widget);
          position();
          toast.hidden = false;
          seen.add(card.querySelector('[data-mse-extra-variant]').dataset.mseExtraVariant);
          lastOffer = Date.now();
          expire();
        } catch (error) {
          toast.hidden = true;
        }
      }, delay);
    });
    document.addEventListener('on:line-item:change', close);
    document.addEventListener('visibilitychange', () => { if (document.hidden) close(); });
    window.addEventListener('resize', () => { if (!toast.hidden) position(); }, { passive: true });
    window.addEventListener('scroll', () => { if (!toast.hidden) position(); }, { passive: true });
    new MutationObserver(() => { if (!toast.hidden) position(); }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mse-cart-free-shipping-upsell"] && !Shopify.designMode) return;
  try {
    (() => {
  let busy = false;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-mse-extra-variant]');
    if (!button) return;
    event.preventDefault();
    if (busy || button.disabled) return;
    const widget = button.closest('[data-mse-cart-extras]');
    const status = widget.querySelector('.mse-cart-extras__status');
    const summary = document.getElementById('cart-summary');
    const outsidePage = !widget.closest('#cart');
    const sectionId = widget.dataset.sectionId;
    const root = window.Shopify.routes.root;
    busy = true;
    widget.querySelectorAll('button').forEach((item) => { item.disabled = true; });
    widget.setAttribute('aria-busy', 'true');
    status.hidden = true;
    let accepted = false;
    let knownRejection = false;
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.mseExtraVariant), quantity: 1, properties: { _mse_recommendation: 'cart', _mse_recommendation_source: button.closest('[data-mse-extra-product]')?.dataset.mseExtraSource || 'consumable', _mse_recommendation_for: widget.dataset.cartProducts || '' } }], sections: [sectionId, 'cart-icon-bubble'], sections_url: window.location.pathname })
      });
      if (response.status >= 400 && response.status < 500) knownRejection = true;
      const data = await response.json();
      if (!response.ok) throw new Error(knownRejection ? widget.dataset.error : widget.dataset.uncertain);
      accepted = true;
      document.dispatchEvent(new CustomEvent('mse:cart:item-added', {
        detail: { source: button, variantId: button.dataset.mseExtraVariant, recommend: false }
      }));
      if (outsidePage) {
        const card = button.closest('.mse-cart-extra');
        if (card) card.remove();
        status.textContent = widget.dataset.added;
        status.hidden = false;
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        document.dispatchEvent(new CustomEvent('mse:cart:refresh'));
        return;
      }
      const html = data.sections && data.sections[sectionId];
      if (!html) { window.location.assign(widget.dataset.cartUrl); return; }
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const freshItems = doc.querySelector('cart-items');
      const freshSummary = doc.getElementById('cart-summary');
      const items = document.querySelector('#cart cart-items');
      if (!items || !freshItems || !summary || !freshSummary) { window.location.assign(widget.dataset.cartUrl); return; }
      items.replaceWith(freshItems);
      summary.replaceWith(freshSummary);
      const pageExtras = document.getElementById('mse-cart-page-extras');
      const freshPageExtras = doc.getElementById('mse-cart-page-extras');
      if (pageExtras && freshPageExtras) pageExtras.replaceWith(freshPageExtras);
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && data.sections['cart-icon-bubble']) {
        const bubbleDoc = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
        const freshBubble = bubbleDoc.querySelector('.shopify-section');
        if (freshBubble) bubble.innerHTML = freshBubble.innerHTML;
      }
      const liveRegion = document.getElementById('cart-live-region-text');
      if (liveRegion) { liveRegion.textContent = widget.dataset.added; liveRegion.setAttribute('aria-hidden', 'false'); }
      document.dispatchEvent(new CustomEvent('mse:cart:refresh'));
      const nextButton = document.querySelector('#mse-cart-page-extras [data-mse-extra-variant]') || freshSummary.querySelector('[name="checkout"]');
      if (nextButton) nextButton.focus({ preventScroll: true });
    } catch (error) {
      if (accepted) { window.location.assign(widget.dataset.cartUrl); return; }
      status.textContent = knownRejection ? widget.dataset.error : widget.dataset.uncertain;
      status.hidden = false;
      if (knownRejection) widget.querySelectorAll('button').forEach((item) => { item.disabled = false; });
    } finally {
      busy = false;
      widget.removeAttribute('aria-busy');
      if (accepted) widget.querySelectorAll('button').forEach(item => { item.disabled = false; });
    }
  });
})();

(() => {
  if (customElements.get('mse-cart-extras')) return;
  const cache = new Map();
  let refreshSequence = 0;
  let refreshTimer;
  const cardsFrom = html => Array.from(new DOMParser().parseFromString(html, 'text/html').querySelectorAll('[data-mse-recommendation-results] > .mse-cart-extra'));
  const recommend = (url, productId) => {
    const key = url + ':' + productId;
    if (!cache.has(key)) {
      const requestUrl = new URL(url, location.origin);
      requestUrl.search = new URLSearchParams({ section_id: 'mse-cart-recommendations', product_id: productId, limit: '10', intent: 'related' });
      cache.set(key, fetch(requestUrl).then(response => {
        if (!response.ok) throw new Error(String(response.status));
        return response.text();
      }).then(cardsFrom).catch(() => { cache.delete(key); return []; }));
    }
    return cache.get(key);
  };
  class CartExtras extends HTMLElement {
    connectedCallback() {
      if (this.dataset.static === 'true') return;
      this.load();
    }
    async load() {
      const version = this.version = (this.version || 0) + 1;
      const ids = (this.dataset.cartProducts || '').split(',').filter(Boolean);
      const excluded = new Set(ids);
      const fallback = Array.from(this.querySelectorAll('[data-mse-extra-reserve] > .mse-cart-extra'));
      const render = automatic => {
        if (!this.isConnected || this.version !== version || this.getAttribute('aria-busy') === 'true') return;
        const selected = [];
        const used = new Set(excluded);
        const usedGroups = new Set();
        const required = fallback.filter(card => card.hasAttribute('data-mse-extra-required'));
        const relevant = automatic.filter(card => card.hasAttribute('data-mse-extra-complement'));
        const pool = this.dataset.mseGelContext === 'true'
          ? [...required, ...fallback.filter(card => card.dataset.mseExtraSource === 'consumable'), ...relevant, ...automatic, ...fallback]
          : [...required, ...automatic, ...fallback];
        for (const card of pool) {
          const id = card.dataset.mseExtraProduct;
          const group = card.dataset.mseExtraGroup || '';
          if (!id || used.has(id)) continue;
          if (group && usedGroups.has(group)) continue;
          used.add(id);
          if (group) usedGroups.add(group);
          selected.push(card.cloneNode(true));
          if (selected.length === 3) break;
        }
        const target = this.querySelector('[data-mse-extra-cards]');
        if (!target || target.contains(document.activeElement)) return;
        target.replaceChildren(...selected);
      };
      render([]);
      const groups = await Promise.all(ids.slice(0, 4).map(id => recommend(this.dataset.recommendationsUrl, id)));
      const automatic = [];
      for (let rank = 0; rank < 10; rank++) for (const group of groups) if (group[rank]) automatic.push(group[rank]);
      render(automatic);
    }
  }
  customElements.define('mse-cart-extras', CartExtras);
  const refresh = async () => {
    const current = ++refreshSequence;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + '?section_id=mse-cart-extras', { cache: 'no-store' });
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (current !== refreshSequence) return;
      const fresh = doc.querySelector('[data-mse-cart-extras]');
      document.querySelectorAll('mse-cart-extras').forEach(widget => {
        if (widget.dataset.static === 'true' || widget.getAttribute('aria-busy') === 'true') return;
        if (!fresh) { widget.remove(); return; }
        if (widget.contains(document.activeElement)) return;
        const replacement = fresh.cloneNode(true);
        replacement.dataset.sectionId = widget.dataset.sectionId;
        widget.replaceWith(replacement);
      });
    } catch (error) {}
  };
  const queue = () => { clearTimeout(refreshTimer); refreshSequence++; refreshTimer = setTimeout(refresh, 180); };
  ['on:cart:add', 'on:line-item:change', 'dispatch:cart-drawer:refresh', 'mse:cart:refresh', 'on:bfcache:load-restore'].forEach(name => document.addEventListener(name, queue));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mse-color-gel-explorer"] && !Shopify.designMode) return;
  try {
    (() => {
  const colorParam = 'mse_color';
  const finishParam = 'mse_finish';
  const legacyColorParam = 'filter.p.tag';
  const knownColorFilters = ['rot','pink','rosa','violett','blau','türkis','grün','gelb','orange','braun','beige','grau','weiß','schwarz','gold','silber','kupfer','bronze','klar'];

  const migrateLegacyColorFilter = () => {
    const url = new URL(window.location.href);
    const legacyValues = url.searchParams.getAll(legacyColorParam);
    if (!legacyValues.length) return false;

    const selected = [];
    const remaining = [];

    legacyValues.forEach((value) => {
      value.split(',').forEach((entry) => {
        const trimmed = entry.trim();
        if (!trimmed) return;
        if (knownColorFilters.includes(trimmed)) {
          if (!selected.includes(trimmed)) selected.push(trimmed);
        } else {
          remaining.push(trimmed);
        }
      });
    });

    if (!selected.length) return false;

    const existing = url.searchParams.get(colorParam);
    const merged = existing
      ? Array.from(new Set(existing.split(',').concat(selected).map((value) => value.trim()).filter(Boolean)))
      : selected;

    url.searchParams.delete(legacyColorParam);
    if (remaining.length) url.searchParams.set(legacyColorParam, remaining.join(','));
    url.searchParams.set(colorParam, merged.join(','));
    url.searchParams.delete('page');

    window.location.replace(url.toString());
    return true;
  };

  if (migrateLegacyColorFilter()) return;

  const getSelectedColors = () => {
    const url = new URL(window.location.href);
    const values = url.searchParams.getAll(colorParam);
    const selected = [];

    values.forEach((value) => {
      value.split(',').forEach((tag) => {
        const trimmed = tag.trim();
        if (trimmed && !selected.includes(trimmed)) selected.push(trimmed);
      });
    });

    return selected;
  };

  const syncColorButtons = () => {
    const selected = getSelectedColors();

    document.querySelectorAll('[data-mse-color-tag]').forEach((button) => {
      const active = selected.includes(button.dataset.mseColorTag);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const toggleColor = (tag) => {
    const url = new URL(window.location.href);
    const selected = getSelectedColors();
    const index = selected.indexOf(tag);

    if (index >= 0) {
      selected.splice(index, 1);
    } else {
      selected.push(tag);
    }

    url.searchParams.delete(colorParam);
    url.searchParams.delete('filter.p.tag');
    url.searchParams.delete('page');

    if (selected.length) url.searchParams.set(colorParam, selected.join(','));

    window.history.replaceState({}, '', url.toString());
    syncColorButtons();
    window.dispatchEvent(new CustomEvent('mse:color-filter-change', {
      detail: { colors: selected }
    }));
  };

  const getSelectedFinish = () => {
    const url = new URL(window.location.href);
    return String(url.searchParams.get(finishParam) || '').trim();
  };

  const syncFinishButtons = () => {
    const selected = getSelectedFinish();
    document.querySelectorAll('[data-mse-finish-tag]').forEach((button) => {
      const value = button.dataset.mseFinishTag || '';
      const active = value === selected;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const toggleFinish = (finish) => {
    const url = new URL(window.location.href);
    const current = getSelectedFinish();
    const next = current === finish ? '' : finish;

    url.searchParams.delete(finishParam);
    url.searchParams.delete('filter.p.tag');
    url.searchParams.delete('page');
    if (next) url.searchParams.set(finishParam, next);

    window.history.replaceState({}, '', url.toString());
    syncFinishButtons();
    window.dispatchEvent(new CustomEvent('mse:finish-filter-change', {
      detail: { finish: next }
    }));
  };

  const normalizeQuickNumber = (value) => {
    const raw = value.trim().replace(/^#/, '').replace(/\s+/g, '');

    if (/^150\d{4,}$/.test(raw)) {
      return { sku: raw, display: raw };
    }

    if (!/^\d{1,4}$/.test(raw)) return null;

    const number = Number.parseInt(raw, 10);
    if (!Number.isFinite(number)) return null;

    if (number <= 999) {
      return {
        sku: `1505${String(number).padStart(3, '0')}`,
        display: String(number).padStart(3, '0')
      };
    }

    return {
      sku: `150${number}`,
      display: String(number)
    };
  };

  let quickCartColorGelQuantity = 0;
  let quickCartLoaded = false;
  let quickCartPromise = null;

  const getQuickInputQuantity = (form) => {
    if (!form) return 0;
    return Array.from(form.querySelectorAll('[data-mse-quick-row]')).reduce((sum, row) => {
      if (row.dataset.mseQuickSubmitted === 'true') return sum;
      const numberInput = row.querySelector('[data-mse-quick-number]');
      const quantityInput = row.querySelector('[data-mse-quick-quantity]');
      if (!numberInput?.value.trim() || !normalizeQuickNumber(numberInput.value)) return sum;
      return sum + Math.max(1, Number.parseInt(quantityInput?.value, 10) || 1);
    }, 0);
  };

  const loadQuickCartColorGelQuantity = async (force = false) => {
    if (quickCartLoaded && !force) return quickCartColorGelQuantity;
    if (quickCartPromise && !force) return quickCartPromise;

    const request = (async () => {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(String(response.status));
        const cart = await response.json();
        quickCartColorGelQuantity = (cart.items || []).reduce((sum, line) => {
          const sku = String(line?.sku || '').trim();
          if (!/^150[15]/.test(sku)) return sum;
          return sum + Math.max(0, Number.parseInt(line.quantity, 10) || 0);
        }, 0);
        quickCartLoaded = true;
      } catch (error) {
        if (!quickCartLoaded) quickCartColorGelQuantity = 0;
      }
      return quickCartColorGelQuantity;
    })();

    quickCartPromise = request;
    try {
      return await request;
    } finally {
      if (quickCartPromise === request) quickCartPromise = null;
    }
  };

  const getQuickTierTop = () => {
    const header = document.querySelector('store-header');
    if (!header) return 8;
    const rect = header.getBoundingClientRect();
    if (rect.bottom <= 0 || rect.top >= window.innerHeight) return 8;
    return Math.max(8, rect.bottom + 8);
  };

  const getQuickTierFloating = (form) => {
    if (form.mseQuickTierFloating?.isConnected) return form.mseQuickTierFloating;
    const floating = document.createElement('div');
    floating.className = 'mse-quick-order__tier mse-quick-order__tier--floating';
    floating.setAttribute('aria-hidden', 'true');
    document.body.appendChild(floating);
    form.mseQuickTierFloating = floating;
    return floating;
  };

  const syncQuickTierFloating = (form) => {
    const container = form?.closest('.mse-quick-order__content');
    const quickOrder = form?.closest('[data-mse-quick-order]');
    const indicator = container?.querySelector('[data-mse-quick-tier]');
    if (!container || !quickOrder || !indicator) return;

    const floating = getQuickTierFloating(form);
    const top = getQuickTierTop();
    const indicatorRect = indicator.getBoundingClientRect();
    const orderRect = quickOrder.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const maxWidth = Math.max(0, window.innerWidth - 20);
    const width = Math.min(containerRect.width, maxWidth);
    const left = Math.max(10, Math.min(containerRect.left, window.innerWidth - width - 10));
    const shouldFloat = quickOrder.open
      && !indicator.hidden
      && indicatorRect.top < top
      && orderRect.bottom > top + 48;

    if (!shouldFloat) {
      floating.classList.remove('is-visible');
      return;
    }

    floating.textContent = indicator.textContent;
    floating.style.top = String(top) + 'px';
    floating.style.left = String(left) + 'px';
    floating.style.width = String(width) + 'px';
    floating.classList.add('is-visible');
  };

  const updateQuickTier = (form) => {
    const container = form?.closest('.mse-quick-order__content');
    const indicator = container?.querySelector('[data-mse-quick-tier]');
    if (!container || !indicator) return;

    const entered = getQuickInputQuantity(form);
    const cartCount = quickCartColorGelQuantity;
    const count = entered + cartCount;

    if (count <= 0) {
      indicator.hidden = true;
      indicator.textContent = '';
      syncQuickTierFloating(form);
      return;
    }

    let message = '';
    if (count < 100) {
      message = container.dataset.tierNextTemplate
        .replace('__COUNT__', String(count))
        .replace('__ENTERED__', String(entered))
        .replace('__CART__', String(cartCount))
        .replace('__REMAINING__', String(100 - count))
        .replace('__PRICE__', '2,99 €');
    } else if (count < 300) {
      message = container.dataset.tierReachedTemplate
        .replace('__COUNT__', String(count))
        .replace('__ENTERED__', String(entered))
        .replace('__CART__', String(cartCount))
        .replace('__REMAINING__', String((count < 200 ? 200 : 300) - count))
        .replace('__CURRENT__', count < 200 ? '2,99 €' : '2,69 €')
        .replace('__PRICE__', count < 200 ? '2,69 €' : '2,31 €');
    } else {
      message = container.dataset.tierBestTemplate
        .replace('__COUNT__', String(count))
        .replace('__ENTERED__', String(entered))
        .replace('__CART__', String(cartCount));
    }

    indicator.textContent = message;
    indicator.hidden = false;
    syncQuickTierFloating(form);
  };

  const refreshQuickTier = async (form, force = false) => {
    await loadQuickCartColorGelQuantity(force);
    updateQuickTier(form);
  };

  const setQuickThumbnail = (row, src = '', alt = '') => {
    const thumb = row.querySelector('[data-mse-quick-thumb]');
    const image = row.querySelector('[data-mse-quick-thumb-img]');
    if (!thumb || !image) return;
    if (!src) {
      thumb.hidden = true;
      image.removeAttribute('src');
      image.alt = '';
      return;
    }
    image.src = src;
    image.alt = alt;
    thumb.hidden = false;
  };

  const getProductHandle = (product) => {
    if (product.handle) return product.handle;
    if (!product.url) return '';

    try {
      const path = new URL(product.url, window.location.origin).pathname;
      const marker = '/products/';
      const index = path.indexOf(marker);
      if (index < 0) return '';
      return decodeURIComponent(path.slice(index + marker.length).split('/')[0]);
    } catch (error) {
      return '';
    }
  };

  const resolveQuickRow = async (row, force = false) => {
    const input = row.querySelector('[data-mse-quick-number]');
    const status = row.querySelector('[data-mse-quick-row-status]');
    const container = row.closest('.mse-quick-order__content');
    const normalized = normalizeQuickNumber(input.value);

    row.classList.remove('is-success', 'is-error');

    if (!normalized) {
      delete row.dataset.variantId;
      delete row.dataset.resolvedValue;
      delete row.dataset.productImage;
      setQuickThumbnail(row);
      if (input.value.trim()) {
        row.classList.add('is-error');
        status.textContent = container.dataset.notFound;
      } else {
        status.textContent = '';
      }
      return null;
    }

    if (!force && row.dataset.variantId && row.dataset.resolvedValue === input.value.trim()) {
      return {
        id: Number(row.dataset.variantId),
        available: row.dataset.available === 'true',
        title: row.dataset.productTitle || '',
        sku: row.dataset.sku || normalized.sku,
        image: row.dataset.productImage || ''
      };
    }

    status.textContent = container.dataset.searching;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const suggestUrl = new URL(root + 'search/suggest.json', window.location.origin);
      suggestUrl.searchParams.set('q', normalized.sku);
      suggestUrl.searchParams.set('resources[type]', 'product');
      suggestUrl.searchParams.set('resources[limit]', '10');
      suggestUrl.searchParams.set('resources[options][fields]', 'title,variants.sku');
      suggestUrl.searchParams.set('resources[options][unavailable_products]', 'last');

      const suggestionResponse = await fetch(suggestUrl.toString(), {
        headers: { Accept: 'application/json' }
      });
      if (!suggestionResponse.ok) throw new Error(String(suggestionResponse.status));

      const suggestionData = await suggestionResponse.json();
      const products = suggestionData?.resources?.results?.products || [];

      let match = null;

      for (const product of products.slice(0, 5)) {
        const handle = getProductHandle(product);
        if (!handle) continue;

        const productResponse = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
          headers: { Accept: 'application/json' }
        });
        if (!productResponse.ok) continue;

        const productData = await productResponse.json();
        const variant = (productData.variants || []).find(
          (candidate) => String(candidate.sku || '').toLowerCase() === normalized.sku.toLowerCase()
        );

        if (variant) {
          match = {
            id: Number(variant.id),
            available: Boolean(variant.available),
            title: productData.title,
            sku: normalized.sku,
            image: variant.featured_image?.src || productData.featured_image || productData.images?.[0] || ''
          };
          break;
        }
      }

      if (!match) {
        row.classList.add('is-error');
        status.textContent = container.dataset.notFound;
        delete row.dataset.variantId;
        delete row.dataset.productImage;
        setQuickThumbnail(row);
        return null;
      }

      const entered = input.value.trim().replace(/^#/, '').replace(/\s+/g, '');
      if (normalized.display && !/^150\d{4,}$/.test(entered)) input.value = normalized.display;
      row.dataset.variantId = String(match.id);
      row.dataset.resolvedValue = input.value.trim();
      row.dataset.available = match.available ? 'true' : 'false';
      row.dataset.productTitle = match.title;
      row.dataset.sku = match.sku;
      row.dataset.productImage = match.image || '';
      setQuickThumbnail(row, match.image || '', match.title || '');

      if (!match.available) {
        row.classList.add('is-error');
        status.textContent = `${match.title} · ${container.dataset.soldOut}`;
        return match;
      }

      row.classList.add('is-success');
      status.textContent = `${container.dataset.found}: ${match.title}`;

      if (!force && document.activeElement === input) {
        const quantityInput = row.querySelector('[data-mse-quick-quantity]');
        if (quantityInput) {
          window.setTimeout(() => {
            quantityInput.focus({ preventScroll: true });
            if (typeof quantityInput.select === 'function') quantityInput.select();
            try {
              quantityInput.setSelectionRange(0, quantityInput.value.length);
            } catch (error) {
            }
          }, 250);
        }
      }

      return match;
    } catch (error) {
      row.classList.add('is-error');
      status.textContent = container.dataset.notFound;
      delete row.dataset.variantId;
      delete row.dataset.productImage;
      setQuickThumbnail(row);
      return null;
    }
  };

  const updateRemoveButtons = (form) => {
    const rows = form.querySelectorAll('[data-mse-quick-row]');
    rows.forEach((row) => {
      const button = row.querySelector('[data-mse-quick-remove]');
      button.hidden = rows.length <= 1;
    });
  };

  const clearResolvedRow = (row) => {
    delete row.dataset.variantId;
    delete row.dataset.resolvedValue;
    delete row.dataset.available;
    delete row.dataset.productTitle;
    delete row.dataset.sku;
    delete row.dataset.productImage;
    delete row.dataset.mseQuickSubmitted;
    setQuickThumbnail(row);
    row.classList.remove('is-success', 'is-error');
    const status = row.querySelector('[data-mse-quick-row-status]');
    if (status) status.textContent = '';
  };

  /* MSE_QUICK_ORDER_AUTO_TRAILING_ROW_V1_20260925 */
  const appendQuickRow = (form, focus = false) => {
    const rowsContainer = form?.querySelector('[data-mse-quick-order-rows]');
    const rows = form ? Array.from(form.querySelectorAll('[data-mse-quick-row]')) : [];
    if (!form || !rowsContainer || !rows.length) return null;

    const clone = rows[0].cloneNode(true);
    const numberInput = clone.querySelector('[data-mse-quick-number]');
    const quantityInput = clone.querySelector('[data-mse-quick-quantity]');

    if (numberInput) numberInput.value = '';
    if (quantityInput) quantityInput.value = '1';

    clearResolvedRow(clone);
    rowsContainer.appendChild(clone);
    updateRemoveButtons(form);
    updateQuickTier(form);

    if (focus && numberInput) {
      window.requestAnimationFrame(() => numberInput.focus());
    }

    return clone;
  };

  const ensureQuickTrailingBlankRow = (form) => {
    if (!form) return;

    const rows = Array.from(form.querySelectorAll('[data-mse-quick-row]'));
    const lastRow = rows[rows.length - 1];
    if (!lastRow) return;

    const lastNumber = lastRow.querySelector('[data-mse-quick-number]');
    if (lastNumber?.value.trim()) appendQuickRow(form, false);
  };

  const closeMseMobileMenu = () => {
    const close = () => {
      const menu = document.querySelector('main-menu');
      if (menu?.closeMainDisclosure) menu.closeMainDisclosure();
      document.body.classList.remove('overflow-hidden', 'fixed');
    };
    if (customElements.get('main-menu')) close();
    else customElements.whenDefined('main-menu').then(close);
  };

  const initMseMenuMode = () => {
    const mode = new URL(window.location.href).searchParams.get('mse_menu');
    if (!['wall', 'quick', 'classic'].includes(mode)) return;
    document.body.classList.add(`mse-color-menu-${mode}`);
    closeMseMobileMenu();
    window.setTimeout(() => {
      if (mode === 'quick') {
        const quick = document.querySelector('[data-mse-quick-order]');
        if (quick) {
          quick.open = true;
          quick.scrollIntoView({ block: 'start' });
        }
        return;
      }
      if (mode === 'classic') {
        const classic = document.getElementById('filter-results') || document.querySelector('.collection-products');
        classic?.scrollIntoView({ block: 'start' });
        return;
      }
      document.querySelector('.mse-color-wall')?.scrollIntoView({ block: 'start' });
    }, 90);
  };

  syncColorButtons();
  syncFinishButtons();
  initMseMenuMode();

  document.addEventListener('click', (event) => {
    const finishButton = event.target.closest('[data-mse-finish-tag]');
    if (finishButton) {
      toggleFinish(finishButton.dataset.mseFinishTag || '');
      return;
    }

    const colorButton = event.target.closest('[data-mse-color-tag]');
    if (colorButton) {
      toggleColor(colorButton.dataset.mseColorTag);
      return;
    }

    const navTag = event.target.closest('[data-mse-nav-tag]');
    if (navTag) {
      event.preventDefault();
      const current = new URL(window.location.href);
      const target = new URL(navTag.href, window.location.origin);
      const colors = current.searchParams.get(colorParam);
      const finish = current.searchParams.get(finishParam);
      const sortBy = current.searchParams.get('sort_by');

      target.searchParams.delete('filter.p.tag');
      if (colors) target.searchParams.set(colorParam, colors);
      if (finish) target.searchParams.set(finishParam, finish);
      if (sortBy) target.searchParams.set('sort_by', sortBy);

      window.location.assign(target.toString());
      return;
    }

    const filterTrigger = event.target.closest('[data-mse-open-filters]');
    if (filterTrigger) {
      const toolbarButton = document.querySelector('.products-toolbar__filter-btn');
      if (toolbarButton) toolbarButton.click();
      return;
    }

    const qtyButton = event.target.closest('[data-mse-quick-qty]');
    if (qtyButton) {
      const row = qtyButton.closest('[data-mse-quick-row]');
      const input = row?.querySelector('[data-mse-quick-quantity]');
      if (!input) return;

      const current = Math.max(1, Number.parseInt(input.value, 10) || 1);
      input.value = qtyButton.dataset.mseQuickQty === 'plus'
        ? current + 1
        : Math.max(1, current - 1);
      const form = row?.closest('[data-mse-quick-order-form]');
      if (form) updateQuickTier(form);
      return;
    }

    const removeButton = event.target.closest('[data-mse-quick-remove]');
    if (removeButton) {
      const form = removeButton.closest('[data-mse-quick-order-form]');
      const row = removeButton.closest('[data-mse-quick-row]');
      if (form && row && form.querySelectorAll('[data-mse-quick-row]').length > 1) {
        row.remove();
        updateRemoveButtons(form);
        ensureQuickTrailingBlankRow(form);
        updateQuickTier(form);
      }
      return;
    }

    const addRowButton = event.target.closest('[data-mse-quick-add-row]');
    if (addRowButton) {
      const form = addRowButton.closest('[data-mse-quick-order-form]');
      if (!form) return;
      appendQuickRow(form, true);
    }
  });

  const focusNextQuickNumber = (quantityInput) => {
    const row = quantityInput.closest('[data-mse-quick-row]');
    const form = row?.closest('[data-mse-quick-order-form]');
    if (!row || !form) return;

    let rows = Array.from(form.querySelectorAll('[data-mse-quick-row]'));
    const index = rows.indexOf(row);
    if (index < 0) return;

    let nextRow = rows[index + 1];
    if (!nextRow) nextRow = appendQuickRow(form, false);

    const nextNumber = nextRow?.querySelector('[data-mse-quick-number]');
    if (!nextNumber) return;

    nextNumber.focus({ preventScroll: true });
    if (nextNumber.value && typeof nextNumber.select === 'function') nextNumber.select();
  };

  document.addEventListener('input', (event) => {
    const quantityInput = event.target.closest('[data-mse-quick-quantity]');
    if (quantityInput) {
      const row = quantityInput.closest('[data-mse-quick-row]');
      if (!row) return;

      const quantity = Number.parseInt(quantityInput.value, 10);
      window.clearTimeout(row.mseQuickQuantityAdvanceTimer);

      const form = row.closest('[data-mse-quick-order-form]');
      if (form) updateQuickTier(form);

      if (Number.isFinite(quantity) && quantity >= 1) {
        row.mseQuickQuantityAdvanceTimer = window.setTimeout(() => {
          if (document.activeElement === quantityInput) focusNextQuickNumber(quantityInput);
        }, 700);
      }
      return;
    }

    const numberInput = event.target.closest('[data-mse-quick-number]');
    if (!numberInput) return;

    const row = numberInput.closest('[data-mse-quick-row]');
    if (!row) return;

    clearResolvedRow(row);

    const form = row.closest('[data-mse-quick-order-form]');
    if (form) updateQuickTier(form);
    if (form) {
      const rows = Array.from(form.querySelectorAll('[data-mse-quick-row]'));
      if (rows[rows.length - 1] === row && numberInput.value.trim()) {
        appendQuickRow(form, false);
      }
    }

    window.clearTimeout(row.mseQuickLookupTimer);
    row.mseQuickLookupTimer = window.setTimeout(() => {
      if (numberInput.value.trim()) resolveQuickRow(row);
    }, 550);
  });

  document.addEventListener('focusout', (event) => {
    const numberInput = event.target.closest('[data-mse-quick-number]');
    if (!numberInput || !numberInput.value.trim()) return;

    const row = numberInput.closest('[data-mse-quick-row]');
    if (row && !row.dataset.variantId) resolveQuickRow(row);
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-mse-quick-order-form]');
    if (!form) return;

    event.preventDefault();

    const content = form.closest('.mse-quick-order__content');
    const message = form.querySelector('[data-mse-quick-message]');
    const submit = form.querySelector('[data-mse-quick-submit]');
    const rows = Array.from(form.querySelectorAll('[data-mse-quick-row]'))
      .filter((row) => row.querySelector('[data-mse-quick-number]')?.value.trim());

    if (!rows.length) {
      message.textContent = content.dataset.enterNumber;
      return;
    }

    submit.disabled = true;
    submit.setAttribute('aria-busy', 'true');
    message.textContent = '';

    try {
      const resolved = await Promise.all(rows.map((row) => resolveQuickRow(row, true)));
      const items = [];

      resolved.forEach((match, index) => {
        if (!match?.available) return;
        const qtyInput = rows[index].querySelector('[data-mse-quick-quantity]');
        const quantity = Math.max(1, Number.parseInt(qtyInput?.value, 10) || 1);
        items.push({ id: match.id, quantity });
      });

      if (!items.length) {
        message.textContent = content.dataset.addError;
        return;
      }

      const root = window.Shopify?.routes?.root || '/';
      const cartDrawer = document.querySelector('cart-drawer');
      const cartDrawerSection = cartDrawer
        ?.closest('.shopify-section')
        ?.id
        ?.replace('shopify-section-', '');
      const sections = ['cart-icon-bubble'];
      if (cartDrawerSection) sections.push(cartDrawerSection);

      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items,
          sections: sections.join(','),
          sections_url: window.location.pathname
        })
      });

      if (!response.ok) throw new Error(String(response.status));
      const data = await response.json();

      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble && data.sections?.['cart-icon-bubble']) {
        const template = document.createElement('template');
        template.innerHTML = data.sections['cart-icon-bubble'];
        const remoteSection = template.content.querySelector('.shopify-section');
        cartIconBubble.innerHTML = remoteSection ? remoteSection.innerHTML : data.sections['cart-icon-bubble'];
      }

      if (cartDrawer && cartDrawerSection && data.sections?.[cartDrawerSection]) {
        cartDrawer.renderContents(data, false);
      }

      rows.forEach((row, index) => {
        if (resolved[index]?.available) {
          row.dataset.mseQuickSubmitted = 'true';
          row.classList.remove('is-error');
          row.classList.add('is-success');
          row.querySelector('[data-mse-quick-row-status]').textContent = content.dataset.added;
        }
      });

      const hasErrors = resolved.some((match) => !match?.available);
      message.textContent = hasErrors ? content.dataset.partialAdded : content.dataset.added;
      await refreshQuickTier(form, true);

      if (!cartDrawer || !cartDrawerSection || !data.sections?.[cartDrawerSection]) {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      }
      window.setTimeout(() => {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
          detail: { opener: submit }
        }));
      }, 350);
    } catch (error) {
      message.textContent = content.dataset.addError;
    } finally {
      submit.disabled = false;
      submit.removeAttribute('aria-busy');
    }
  });

  const syncAllQuickTierFloating = () => {
    document.querySelectorAll('[data-mse-quick-order-form]').forEach(syncQuickTierFloating);
  };

  let quickTierFloatingFrame = 0;
  const scheduleQuickTierFloating = () => {
    if (quickTierFloatingFrame) return;
    quickTierFloatingFrame = window.requestAnimationFrame(() => {
      quickTierFloatingFrame = 0;
      syncAllQuickTierFloating();
    });
  };

  window.addEventListener('scroll', scheduleQuickTierFloating, { passive: true });
  window.addEventListener('resize', scheduleQuickTierFloating);
  window.addEventListener('on:debounced-resize', scheduleQuickTierFloating);
  document.addEventListener('toggle', scheduleQuickTierFloating, true);

  document.addEventListener('mse:color-wall:cart-updated', (event) => {
    const count = event.detail?.colorGelCount;
    if (!Number.isFinite(count)) return;
    quickCartColorGelQuantity = count;
    quickCartLoaded = true;
    document.querySelectorAll('[data-mse-quick-order-form]').forEach(updateQuickTier);
  });

  ['cart:updated', 'cart:refresh', 'cart:change', 'on:cart:change'].forEach((name) => {
    document.addEventListener(name, async () => {
      await loadQuickCartColorGelQuantity(true);
      document.querySelectorAll('[data-mse-quick-order-form]').forEach(updateQuickTier);
    });
  });

  document.querySelectorAll('[data-mse-quick-order-form]').forEach((form) => {
    updateRemoveButtons(form);
    updateQuickTier(form);
    refreshQuickTier(form).then(() => {
      syncQuickTierFloating(form);
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mse-global-checkout"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const bar = document.getElementById('mse-global-checkout');
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = 'true';
    const space = document.getElementById('mse-global-checkout-space');
    const button = bar.querySelector('button');
    const extras = bar.querySelector('[data-mse-global-extras]');
    const extrasContent = bar.querySelector('[data-mse-global-extras-content]');
    let extrasSignature = '';
    const shipping = bar.querySelector('[data-mse-global-shipping]');
    const syncShipping = (cart) => {
      document.querySelectorAll('[data-mse-global-shipping]').forEach((notice) => {
        const minimum = Number(notice.dataset.minimum);
        const supported = cart.currency === notice.dataset.currency && minimum > 0 && cart.requires_shipping !== false && cart.item_count > 0;
        notice.hidden = !supported;
        if (!supported) return;
        const deficit = Math.max(0, minimum - cart.total_price);
        const amount = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: cart.currency }).format(deficit / 100);
        const text = deficit === 0 ? notice.dataset.reached : notice.dataset.pending.replace('__MSE_AMOUNT__', amount);
        const heading = notice.querySelector('[data-mse-global-shipping-text]');
        if (heading.textContent !== text) heading.textContent = text;
        const progress = Math.min(100, Math.max(0, cart.total_price / minimum * 100));
        notice.querySelector('[data-mse-global-shipping-fill]').style.width = progress + '%';
        notice.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', String(Math.round(progress)));
        notice.classList.toggle('is-reached', deficit === 0);
      });
    };
    const size = () => {
      if (bar.hidden) return;
      const height = Math.ceil(bar.getBoundingClientRect().height);
      space.style.height = height + 'px';
      document.documentElement.style.setProperty('--mse-global-checkout-height', height + 'px');
    };
    let itemCount = Number(bar.dataset.itemCount);
    let frame = 0;
    let timer = 0;
    let requestId = 0;
    const visible = (element) => {
      if (!element) return false;
      const rect = element.getBoundingClientRect();
      const style = getComputedStyle(element);
      return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight && style.visibility !== 'hidden' && style.display !== 'none';
    };
    const busy = () => Boolean(document.querySelector('[data-mse-color-wall-item].is-adding, product-form [name="add"][aria-disabled="true"], cart-items.pointer-events-none'));
    const update = () => {
      frame = 0;
      const focused = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
      const dialog = Array.from(document.querySelectorAll('[role="dialog"][aria-hidden="false"], dialog[open]')).some(visible);
      const nativeVisible = Array.from(document.querySelectorAll('#cart-summary [name="checkout"], .mse-color-wall__checkout')).some(visible);
      const show = itemCount > 0 && window.scrollY > 120 && !focused && !dialog && !nativeVisible;
      if (bar.hidden === show) bar.hidden = !show;
      if (space.hidden === show) space.hidden = !show;
      size();
      const disabled = busy();
      if (button.disabled !== disabled) button.disabled = disabled;
      document.querySelectorAll('[data-mse-cart-primary]').forEach((link) => {
        const value = String(disabled);
        if (link.getAttribute('aria-disabled') !== value) link.setAttribute('aria-disabled', value);
      });
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const refresh = async () => {
      const current = ++requestId;
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!response.ok) throw new Error(String(response.status));
        const cart = await response.json();
        if (current !== requestId) return;
        itemCount = cart.item_count;
        const signature = JSON.stringify([cart.currency, cart.items.map(item => [item.key, item.quantity])]);
        if (signature !== extrasSignature) {
          const extraResponse = await fetch((window.Shopify?.routes?.root || '/') + '?section_id=mse-cart-extras', { cache: 'no-store' });
          if (extraResponse.ok && current === requestId) {
            const extraDoc = new DOMParser().parseFromString(await extraResponse.text(), 'text/html');
            if (current !== requestId) return;
            const widget = extraDoc.querySelector('[data-mse-cart-extras]');
            extrasContent.replaceChildren();
            if (widget) extrasContent.append(widget);
            extras.hidden = !widget;
            if (!widget) extras.open = false;
            extrasSignature = signature;
          }
        }
        syncShipping(cart);
        const total = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: cart.currency }).format(cart.total_price / 100);
        document.querySelectorAll('[data-mse-checkout-total]').forEach((element) => { if (element.textContent !== total) element.textContent = total; });
        schedule();
      } catch (error) {
        if (current === requestId) {
          document.querySelectorAll('[data-mse-global-shipping]').forEach(notice => { notice.hidden = true; });
          extras.hidden = true;
          document.querySelectorAll('[data-mse-checkout-total]').forEach((element) => { element.textContent = '—'; });
          schedule();
        }
      }
    };
    const queueRefresh = () => { clearTimeout(timer); timer = setTimeout(refresh, 120); };
    ['on:cart:add', 'on:line-item:change', 'dispatch:cart-drawer:refresh', 'on:bfcache:load-restore', 'mse:cart:refresh'].forEach((eventName) => document.addEventListener(eventName, queueRefresh));
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', queueRefresh);
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', schedule);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) queueRefresh(); });
    new MutationObserver(schedule).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'aria-hidden', 'aria-disabled', 'open'] });
    const icon = document.getElementById('cart-icon-bubble');
    if (icon) new MutationObserver(queueRefresh).observe(icon, { subtree: true, childList: true, characterData: true });
    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-mse-cart-primary]') && busy()) event.preventDefault();
    });
    bar.querySelector('form').addEventListener('submit', (event) => {
      if (busy()) { event.preventDefault(); return; }
      const nativeButton = document.querySelector('#cart-summary [name="checkout"]');
      if (nativeButton) { event.preventDefault(); nativeButton.click(); }
    });
    new ResizeObserver(size).observe(bar);
    update();
    queueRefresh();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mse-lash-tray-selector"] && !Shopify.designMode) return;
  try {
    function initMseLashQuickBuy() {
  document.querySelectorAll('.mse-lash-quick-buy').forEach((quickBuy) => {
    const productRoot = quickBuy.closest('.cc-main-product');
    const normalAddToCart = productRoot?.querySelector('.product-info__add-to-cart');

    const updateVisibility = () => {
      if (!normalAddToCart) {
        quickBuy.classList.add('is-visible');
        quickBuy.setAttribute('aria-hidden', 'false');
        return;
      }

      const rect = normalAddToCart.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      const normalButtonFullyVisible =
        rect.top >= 0 &&
        rect.bottom <= viewportHeight - 8 &&
        rect.height > 0;

      quickBuy.classList.toggle('is-visible', !normalButtonFullyVisible);
      quickBuy.setAttribute('aria-hidden', normalButtonFullyVisible ? 'true' : 'false');
    };

    let frame = 0;
    const requestUpdate = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        updateVisibility();
      });
    };

    updateVisibility();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    window.setTimeout(updateVisibility, 100);
    window.setTimeout(updateVisibility, 500);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMseLashQuickBuy, { once: true });
} else {
  initMseLashQuickBuy();
}

document.addEventListener('click', (event) => {
  const minus = event.target.closest('[data-mse-lash-qty-minus]');
  const plus = event.target.closest('[data-mse-lash-qty-plus]');
  if (!minus && !plus) return;

  const quickBuy = event.target.closest('.mse-lash-quick-buy');
  const input = quickBuy?.querySelector('.mse-lash-quick-buy__qty-input');
  if (!input) return;

  const current = Math.max(1, Number.parseInt(input.value, 10) || 1);
  input.value = plus ? current + 1 : Math.max(1, current - 1);
  input.dispatchEvent(new Event('change', { bubbles: true }));
});
  } catch(e) { console.error(e); }
})();

})();
